<template>
  <div class="custom-page-box">
    <a-card title="团队信息" :bordered="false" :headStyle="{fontSize:'18px'}">
      <search-page-view
        :col="3"
        ref="pageList"
        :itemNames="['search_1','search_2','search_3','search_4','search_5','search_6']"
        :columns="getColumns()"
        :queryParams="queryParams"
        :leftSpace="30"
        :enableSearch='false'
        :customPagination="true"
        :requestPromise="getListPromise"
      >
        <a-form-item slot="search_1" label="姓名" v-bind="searchItemLayout">
          <a-input v-model="queryParams.staff_name" placeholder="请输入"/>
        </a-form-item>
        <a-form-item slot="search_2" label="手机号" v-bind="searchItemLayout">
          <a-input v-model="queryParams.staff_mobile" placeholder="请输入"/>
        </a-form-item>
        <a-form-item slot="search_3" label="加入时间" v-bind="searchItemLayout">
          <!--          :disabledDate="disabledDate"-->
          <a-range-picker
            @change="onDateChange"
            :allowClear="false"
            :value="selectedDate"
            style="width: 100%"/>
        </a-form-item>
        <a-form-item slot="search_4" label="交易时间" v-bind="searchItemLayout">
          <a-range-picker
            :allowClear="false"
            @change="onDateTransactionChange"
            :value="transactionDate"
            style="width: 100%"/>
        </a-form-item>
        <a-form-item slot="search_5" label="分组名称" v-bind="searchItemLayout">
          <a-select
            mode="multiple"
            v-model="queryParams.staff_group_id"
            placeholder="请选择"
            option-label-prop="label"
            style='width: 100%;'
            allowClear
          >
            <a-select-option v-for="item in groupArrList" :key="item.id" :value="item.id" :label="item.name">
              <span role="img" :aria-label="item.name">{{ item.name }}</span>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item slot="search_6" label="种子二分" v-bind="searchItemLayout">
          <div style="display: flex;justify-content: space-between;align-items: center">
            <a-checkbox v-model="queryParams.is_seeded_staff">是</a-checkbox>
            <div>
              <a-button type="primary" @click='onclickQuery'>查询</a-button>
              <a-button style="margin-left: 10px" @click="exportData">导出</a-button>
            </div>
          </div>
        </a-form-item>
        <a-form-item slot="operation">
          <div class="status-list-custom">
            <div class="status-list-custom-item">
              <div class="text">成员数量</div>
              <div class="heading">{{ totalForm.user_add_total_number ? totalForm.user_add_total_number : 0 }}</div>
            </div>
            <div class="status-list-custom-item">
              <div class="text">
                累计订单数量
                <a-tooltip placement="right" title="该字段只统计种子二分数据">
                  <a-icon type="question-circle" theme="filled"/>
                </a-tooltip>
              </div>
              <div class="heading">{{ isShowTotal ? totalForm.order_add_total_number || 0 : '******' }}</div>
            </div>
            <div class="status-list-custom-item">
              <div class="text">
                累计营业额
                <a-tooltip placement="right" title="该字段只统计种子二分数据">
                  <a-icon type="question-circle" theme="filled"/>
                </a-tooltip>
              </div>
              <div class="heading">
                <span v-if="isShowTotal">
                 <i>￥</i><span class="active">{{ totalForm.sell_add_total_amount || 0 }}</span>
                </span>
                <span v-else>
                  ******
                </span>
              </div>
            </div>
          </div>
        </a-form-item>
        <span slot="action" slot-scope="rowItem">
          <a @click="toDetailEvent(rowItem.record)">查看详情</a>
        </span>
      </search-page-view>
    </a-card>
  </div>
</template>

<script>
import searchForm from '../../../utils/mixins/searchFormMixins'
import moment from 'moment'

export default {
  name: 'TeamInformationList',
  mixins: [searchForm],
  data() {
    return {
      queryParams: {
        is_seeded_staff: false,
        user_start_date: moment().subtract('days', 366).format('YYYY-MM-DD'),
        user_end_date: moment().subtract('days', 1).format('YYYY-MM-DD'),
        order_start_date: moment().subtract('days', 366).format('YYYY-MM-DD'),
        order_end_date: moment().subtract('days', 1).format('YYYY-MM-DD')
      },
      selectedDate: null,
      transactionDate: null,
      totalForm: {
        user_add_total_number: 0,
        order_add_total_number: 0,
        sell_add_total_amount: 0
      },
      groupArrList: [],
      isShowTotal: false
    }
  },
  mounted() {
    let startTime = moment().subtract('days', 366).format('YYYY-MM-DD')
    let endTime = moment().subtract('days', 1).format('YYYY-MM-DD')
    this.selectedDate = [moment(startTime), moment(endTime)]
    this.transactionDate = [moment(startTime), moment(endTime)]
    this.getGroupListPromise()
  },
  methods: {
    disabledDate(current) {
      return current && current > moment().subtract(1, 'days')
    },
    getGroupListPromise() {
      const params = {
        catalog: 2,//分组类型 1自动分组 2手动分组
        limitDto: {
          pageNum: 1,
          pageSize: 1000
        }
      }
      this.getHttpServices().getUserService().post('merchant/v2/group/getGroupList', params).then(res => {
        this.getLogUtils().errorWithTag('getGroupListPromise', res)
        if (res && res.data && res.data.length > 0) {
          this.groupArrList = res.data
        }
      }).catch(err => {
        this.getLogUtils().errorWithTag('getGroupListPromise', err)
      })
    },
    onclickQuery() {
      this.$refs.pageList.refresh(true)
    },
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.user_start_date = dateStrArr[0]//开始日期
      this.queryParams.user_end_date = dateStrArr[1]//结束日期
    },
    onDateTransactionChange(dates, dateStrArr) {
      this.transactionDate = dates
      this.queryParams.order_start_date = dateStrArr[0]//开始日期
      this.queryParams.order_end_date = dateStrArr[1]//结束日期
    },
    exportData() {
      this.getHttpServices().getUserService().post('daily/report/merchant/list/export', this.queryParams)
        .then(res => {
          this.$message.success('操作成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params, parameter) {
      let newParams = {
        ...params,
        orderBy: 0
      }
      if (parameter && parameter.sortField) {
        if (parameter.sortField == 'user_add_total_number') {
          newParams.orderBy = parameter.sortOrder ? (parameter.sortOrder == 'ascend' ? 1 : 2) : 0
        }
        if (parameter.sortField == 'order_add_total_number') {
          newParams.orderBy = parameter.sortOrder ? (parameter.sortOrder == 'ascend' ? 3 : 4) : 0
        }
        if (parameter.sortField == 'sell_add_total_amount') {
          newParams.orderBy = parameter.sortOrder ? (parameter.sortOrder == 'ascend' ? 5 : 6) : 0
        }
      }
      this.queryParams.orderBy = newParams.orderBy
      this.getStaffTotalAmount(params)
      return this.getHttpServices().getUserService().post('daily/report/merchant/list', newParams)
    },
    getStaffTotalAmount(params) {
      this.getHttpServices().getUserService().post('daily/report/merchant/total', params).then(res => {
        this.getLogUtils().errorWithTag('getStaffTotalAmount', params)
        this.isShowTotal = false
        if (this.queryParams.is_seeded_staff) {
          this.isShowTotal = true
        }
        if (res) {
          this.totalForm = res
        } else {
          this.totalForm = {
            user_add_total_number: 0,
            order_add_total_number: 0,
            sell_add_total_amount: 0
          }
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    toDetailEvent(record) {
      let params = {
        staff_id: record.staff_id
      }
      this.openNewPage('TeamInformationDetail', params)
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'staff_id'
        },
        {
          title: '姓名',
          dataIndex: 'staff_name'
        },
        {
          title: '手机号',
          dataIndex: 'staff_mobile'
        },
        {
          title: '团队人数',
          dataIndex: 'user_add_total_number',
          sorter: true
        },
        {
          title: '团队订单数量',
          dataIndex: 'order_add_total_number',
          sorter: true
        },
        {
          title: '团队营业额',
          dataIndex: 'sell_add_total_amount',
          sorter: true
        }, {
          title: '分组名称',
          dataIndex: 'group_name_str'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }

}
</script>
<style lang="less">
@import "../../CustomPage";

.status-list-custom {
  background-color: #F5F5F6;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .status-list-custom-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .heading {
    .active {
      color: #f5222d;
    }

    i {
      font-size: 11px;
      font-style: normal;
    }
  }
}
</style>
<style lang='less' scoped>
.custom-page-box {
  position: relative;
}

.ml10 {
  margin-left: 10px;
}

.footer-btns {
  text-align: right;
  padding-top: 20px;
}
</style>